import { getBalance } from './getBalance.js';
import { getTransactionFee } from './getTransactionFee.js';
import { getUTXOs } from './getUTXOs.js';
export const blockchairMethods = {
    getBalance,
    getUTXOs,
    getTransactionFee,
};
//# sourceMappingURL=methods.js.map